import { useCallback } from 'react';
import { reduxTypedHooks, lessonTaskActions } from 'common/modules/ReactShared';

function useHeartBeatPing(): () => void {
  const dispatch = reduxTypedHooks.useTypedDispatch();
  const pingAction = useCallback(() => {
    dispatch(lessonTaskActions.heartBeat());
  }, [dispatch]);
  return pingAction;
}

export default useHeartBeatPing;
